import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../api/client.jsx';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';
import { useApiMutation } from '../../api/mutations';
import {
  policyFixture,
  policyDiagnoseFixture,
  createPolicyVersionFixture,
  activatePolicyNowFixture,
} from './fixture';

const INVALIDATE = ['policy', 'policyDiagnose'];

export function usePolicy() {
  const { fetch } = useApiClient();
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['policy', fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) {
        await fixtureDelay();
        return policyFixture();
      }
      return fetch('/v1/admin/policy');
    },
  });
}

export function usePolicyDiagnose(brandOrigin) {
  const { fetch } = useApiClient();
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['policyDiagnose', brandOrigin, fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) {
        await fixtureDelay(150);
        return policyDiagnoseFixture(brandOrigin);
      }
      return fetch('/v1/admin/policy/diagnose');
    },
  });
}

export function useCreatePolicyVersion() {
  return useApiMutation({
    live: (fetch, body) => fetch('/v1/admin/policy', { method: 'POST', body }),
    fixture: (body) => createPolicyVersionFixture(body),
    invalidate: INVALIDATE,
    successMessage: (res) =>
      `Version "${res.version.version}" für ${res.version.documentType} angelegt.`,
  });
}

export function useActivatePolicyNow() {
  return useApiMutation({
    live: (fetch, { id }) =>
      fetch(`/v1/admin/policy/${id}/activate-now`, { method: 'POST' }),
    fixture: ({ id }) => activatePolicyNowFixture(id),
    invalidate: INVALIDATE,
    successMessage: 'Version sofort wirksam gesetzt.',
  });
}
